import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a880396"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "schedule-table",
  role: "region",
  "aria-label": "출발 시간표"
}
const _hoisted_2 = { class: "timetable-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "hour"
    }, "시간대"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "times"
    }, "출발 시각")
  ])
], -1 /* HOISTED */))
const _hoisted_4 = {
  scope: "row",
  class: "hour"
}
const _hoisted_5 = { class: "times" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departureTimeByHour, (row) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.hour,
            class: _normalizeClass({ 'first-row-only': $setup.departureTimeByHour.length === 1 })
          }, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(row.hour), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.minutes, (minute, idx) => {
                return (_openBlock(), _createElementBlock("span", { key: minute }, [
                  _createElementVNode("span", null, _toDisplayString(minute), 1 /* TEXT */),
                  (idx !== row.minutes.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " / "))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}